import { PostWithDetails } from '../models';
import { PostRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetUserPostsUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(targetUserId: string, requestingUserId: string, limit: number = 20, offset: number = 0): Promise<PostWithDetails[]> {
    logger.debug('GetUserPosts', 'Fetching user posts', { targetUserId, requestingUserId, limit, offset });

    const posts = await this.postRepository.getUserPosts(targetUserId, requestingUserId, limit, offset);

    logger.debug('GetUserPosts', 'User posts fetched', { count: posts.length });

    return posts;
  }
}
